const getDefaultState = () => {
    return {
        user: [],
        loggedIn: false,
        loggedInUser: null
    }
}

const state = getDefaultState();

const getters = {
    isLoggedIn(state) {
        return state.loggedIn
    },
    loggedInUser(state) {
        return state.loggedInUser;
    },
    segmentValue(state) {
        return state.segmentValue;
    },
    segmentCircle(state) {
        return state.segmentCircle;
    },
    redeem_url(state) {
        return state.redeem_url;
    },
    stripeAccountId(state) {
        return state.loggedInUser?.stripeAccountId;
    }
};
const actions = {
    signup({commit}, payload) {
        commit('addUser', JSON.parse(payload));
        return {
            status: 'success',
            user: payload
        };
    },
    updateStripeId({commit}, payload) {
        commit('updateStripeId', payload);
        return Promise.resolve();
    },
    updateBalance({commit}, payload) {
        commit('updateBalance', payload);
    },
    updateUnClearBalance({commit}, payload) {
        commit('updateUnClearBalance', payload);
    },
    segmentTab({commit}, payload) {
        commit('segmentTab', payload);
    },
    segmentTab1({commit}, payload) {
        commit('segmentTab1', payload);
    },
    redeemUrl({commit}, payload) {
        commit('redeemUrl', payload);
    },
    updateProfile({ commit, state }, payload) {
        commit('updateProfile', payload);
        return state.loggedInUser;
    },
    updateProfileImage({commit}, payload) {
        commit('updateProfileImage', payload);
    },
    updatePaymentMethod({commit}, payload) {
        commit('updatePaymentMethod', payload);
    },
    login({commit}, payload) {
        commit('loggedIn', payload);
    },
    logout({commit}) {
        commit('logOut');
    },
};
const mutations = {
    loggedIn(state, payload) {
        state.loggedIn = true;
        state.loggedInUser = payload;
    },
    addUser(state, payload) {
        state.user = payload;
    },
    logOut(state) {
        Object.assign(state, getDefaultState());
    },
    updateStripeId(state, payload) {
        const { stripeAccountId } = payload;

        if (state.loggedInUser) {
            state.loggedInUser.stripeAccountId = stripeAccountId;
        }
    },
    updateBalance(state, payload) {
        // Object Destructuring
        const {balance, available_balance} = payload;
        state.balance = balance;
        state.available_balance = available_balance;
    },
    updateUnClearBalance(state, payload) {
        // Object Destructuring
        state.unclear_balance = payload;
    },
    segmentTab(state, payload) {
        // Object Destructuring
        state.segmentValue = payload;
    },
    segmentTab1(state, payload) {
        // Object Destructuring
        state.segmentCircle = payload;
    },
    redeemUrl(state, payload) {
        // Object Destructuring
        state.redeem_url = payload;
    },
    updateProfileImage(state, payload) {
        // Object Destructuring
        state.loggedInUser.user_image = payload;
    },
    updateProfile(state, payload) {
        if (!state.loggedInUser) return;
        // Map payload keys to state keys (payload may send 'state', mutation previously used 'st')
        const keyMap = {
            first_name: 'first_name',
            last_name: 'last_name',
            user_image: 'user_image',
            birth_day: 'birth_day',
            anniversary: 'anniversary',
            holidays: 'holidays',
            address: 'address',
            state: 'state',
            st: 'state',
            city: 'city',
            postalCode: 'postalCode',
            ssn: 'ssn',
            global_approval: 'global_approval',
            authFlag: 'authFlag',
            textReceive: 'textReceive',
            textSend: 'textSend',
            textReceiveNotification: 'textReceiveNotification',
            textSendNotification: 'textSendNotification',
            textActivityNotification: 'textActivityNotification',
            emailReceiveNotification: 'emailReceiveNotification',
            emailSendNotification: 'emailSendNotification',
            emailActivityNotification: 'emailActivityNotification',
        };
        Object.keys(keyMap).forEach((payloadKey) => {
            if (Object.prototype.hasOwnProperty.call(payload, payloadKey)) {
                const stateKey = keyMap[payloadKey];
                state.loggedInUser[stateKey] = payload[payloadKey];
            }
        });
    }
    ,
    updatePaymentMethod(state, payload) {
        if (state.loggedInUser) {
            state.loggedInUser.paymentMethod = !!payload;
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
